/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Merge_DownInputs */

const en_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Down`)
};

const fr_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner vers le bas`)
};

const de_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen`)
};

const it_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci verso il basso`)
};

const ru_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние вниз`)
};

const es_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar hacia abajo`)
};

const zh_cn2_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下合并`)
};

const ja_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下へマージ`)
};

const hi_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे विलय करें`)
};

const pt_pt2_shortcut_keys_name_merge_down = /** @type {(inputs: Shortcut_Keys_Name_Merge_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar para baixo`)
};

/**
* | output |
* | --- |
* | "Merge Down" |
*
* @param {Shortcut_Keys_Name_Merge_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_merge_down = /** @type {((inputs?: Shortcut_Keys_Name_Merge_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Merge_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_merge_down(inputs)
	if (locale === "de") return de_shortcut_keys_name_merge_down(inputs)
	if (locale === "it") return it_shortcut_keys_name_merge_down(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_merge_down(inputs)
	if (locale === "es") return es_shortcut_keys_name_merge_down(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_merge_down(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_merge_down(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_merge_down(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_merge_down(inputs)
	return en_shortcut_keys_name_merge_down(inputs)
});